<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Solution',
})
</script>
<template>
  <div v-if="componentDataList.length" class="solution-preview">
    <template
      v-for="item in componentDataList"
      :key="`${route.params.id}-${item.id}`"
    >
      <client-only v-if="item.type === ComponentsTypeEnum.EXP_TEMPLATE">
        <component
          :componentId="item.id"
          :type="'open'"
          :isLogin="isLogin"
          :is="currentComponent(item.type)"
          :sid="sid"
          :source="source"
          :navTop="64"
          :style="{
            backgroundColor: getBgColor(item.id),
            paddingBottom: getIsLast(item.id) ? '72px' : '0'
          }"
          :data="item.componentsInfo"
          @load-result="handleLoadResult"
          @login-success="loginSuccess"
        />
      </client-only>
      <component
        v-else
        :componentId="item.id"
        :type="'open'"
        :isLogin="isLogin"
        :isHasPhone="isHasPhone"
        :is="currentComponent(item.type)"
        :sid="sid"
        :source="source"
        :navTop="64"
        :style="{
          backgroundColor: getBgColor(item.id),
          paddingBottom: getIsLast(item.id) ? '72px' : '0',
          display: getBlock(item.componentsInfo) ? 'none' : ''
        }"
        :data="item.componentsInfo"
        @load-result="handleLoadResult"
        @open-bind-dialog="openBindDialog"
        @login-success="loginSuccess"
        @login-bind-success="loginSuccess"
      />
    </template>
    <Transition name="normal-dialog">
      <NormalDialog
        v-if="dialogVisible"
        :data="dialogInfo.modelData"
        :dialogType="dialogInfo.dialogType"
        :isLogin="isLogin"
        :source="source"
        @close-dialog="handleCloseDialog"
      />
    </Transition>
  </div>
  <div v-else>
    <Transition name="normal-dialog">
      <NormalDialog
        v-if="dialogVisible"
        :data="dialogInfo.modelData"
        :dialogType="dialogInfo.dialogType"
        :isLogin="isLogin"
        :source="source"
        @close-dialog="handleCloseDialog"
      />
    </Transition>
  </div>
</template>
<script setup lang="ts" name="Solution">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import {
  ComponentDataType,
  PICTURE_BANNER_TYPE,
  PICTURE_COMPONENT_TYPE,
  PICTURE_NAV_TYPE
} from './interface'
import { ComponentsTypeEnum, COLOR_ENUM } from './constant'
import { ShowComponentMap } from './componentSettings'

import { setTitle, setTDK, insertElement } from '@/utils/util'
import { replaceToPageBypath } from '@/utils/routerUtil'
import { GlobalStore } from '@/store'
import { SSRDataStore } from '@/store/modules/ssrData'
import {
  NOT_FIND,
  WEATHER_COLLECT,
  AUTH_INFO,
  LOGIN,
  CREATE_ORDER
} from '@/router/constant'
import { isArray, isClient, isJsonString } from '@/utils/is'

import { getDialogList } from '@/api/modules/dialog'
import NormalDialog from '@/components/NormalDialog/Index.vue'
import {
  isPageFirstIncome,
  setPageFirstIncomeInfo,
  isNewUser,
  setNewUser
} from '@/utils/showDialog'
import { openRelatedAccountDialog } from '@/utils/dialogService'
import relatedAccount from '@/components/BindUser/index.vue'
import { openWindowByquery } from '@/utils/routerUtil'
import Cookies from 'js-cookie'
import { useLoginWithRedirect } from '@/hooks/useLogin'
const createorderUrl = import.meta.env.VITE_CREATEODERURL
const ssoLogin: Function = inject('ssoLogin') as Function
const handleLoginSuccess: Function = inject('handleLoginSuccess') as Function
const globalStore = GlobalStore()
const ssrDataStore = SSRDataStore()

// 获取实例
const route = useRoute()
const router = useRouter()

const isLoading = ref(false)

const productComponents = ref()

const componentDataList = ref<ComponentDataType[]>([])

const source = ref('')

const sid = ref('')
const targetPageUrl = ref('')
const isLogin = computed(() => {
  return !!globalStore && !!globalStore.token
})
const isHasPhone = computed(() => {
  return globalStore.userInfo.phone ? true : false
})
const authType = computed(() => {
  if (!isLogin.value || !globalStore.userAuthInfo) {
    return 0
  }
  return globalStore.userAuthInfo?.type || 0
})

const userId = computed(() => {
  if (!isLogin.value || !globalStore.userAuthInfo) {
    return ''
  }
  return globalStore.userAuthInfo?.userId || ''
})

const token = computed(() => {
  return globalStore?.token || ''
})

const isBannerImageLoad = ref(false)

const handleLoadResult = () => {
  isBannerImageLoad.value = true
}
const initPageData = () => {
  if (productComponents.value) {
    const {
      campaignIds,
      moduleContent,
      title,
      id,
      tdkTitle,
      tdkDescription,
      tdkKeywords,
      topLinkUrl,
      topPicUrl,
      bottomLinkUrl,
      bottomPicUrl
    } = productComponents.value
    const campaignIdsData = campaignIds || []
    componentDataList.value = isJsonString(moduleContent)
      ? JSON.parse(moduleContent)
      : []
    source.value = title
    sid.value = id + ''
    const TDKData =
      isArray(componentDataList.value) && componentDataList.value.length
        ? componentDataList.value.find(
            (item) => item.type === ComponentsTypeEnum.PICTURE_BANNER
          )
        : null
    if (
      componentDataList.value.findIndex(
        (item) => item.type === ComponentsTypeEnum.PICTURE_BANNER
      ) < 0
    ) {
      isBannerImageLoad.value = true
    }
    let titleIndex = componentDataList.value.findIndex(
      (item) => item.type === ComponentsTypeEnum.TITLE
    )
    const couponIndex = componentDataList.value.findIndex(
      (item) => item.type === ComponentsTypeEnum.COUPON
    )
    if (titleIndex >= 0 && couponIndex === -1 && campaignIdsData.length) {
      componentDataList.value.splice(titleIndex, 0, {
        id: '',
        type: ComponentsTypeEnum.COUPON,
        isHover: false,
        isEdit: false,
        componentsInfo: { title: '' }
      })
    }

    setTitle(tdkTitle || `${title}-星图云开放平台`)
    const keywords = tdkKeywords || title

    const description =
      tdkDescription ||
      (TDKData ? (TDKData?.componentsInfo as PICTURE_BANNER_TYPE).content : '')

    setTDK(keywords, description)

    // 客户端差批量配置的图片
    if (isClient()) {
      nextTick(() => {
        insertElement(topPicUrl, topLinkUrl, bottomPicUrl, bottomLinkUrl)
      })
    }
  }
}

const initPage = async () => {
  try {
    const id = route.params.id?.toString()

    if (id && id !== 'undefined' && !isLoading.value) {
      isLoading.value = true
      await ssrDataStore.setSolutionProductData(id)
      productComponents.value = ssrDataStore.componentsGet
    }
  } catch (error) {
    replaceToPageBypath(NOT_FIND)
    componentDataList.value = []
  } finally {
    isLoading.value = false
  }
}

if (isClient() && ssrDataStore.componentsGet) {
  productComponents.value = ssrDataStore.componentsGet
  initPageData()
}

const dialogInfo: any = reactive({
  name: '',
  modelData: '',
  triggerType: '',
  dialogType: ''
})

const dialogVisible = ref(false)
getDialogList()
  .then((res) => {
    const id = route.params.id?.toString()
    const dialogItem = res.data.find((it: any) => it.englishTitles.includes(id))
    if (dialogItem) {
      Object.assign(dialogInfo, {
        name: dialogItem.name,
        modelData: JSON.parse(dialogItem.styleJson),
        triggerType: dialogItem.triggerType,
        dialogType: dialogItem.dialogType
      })
    }
    if (!dialogInfo.triggerType) {
      return
    }
    if (dialogInfo.triggerType == 1 && !isNewUser()) {
      dialogVisible.value = true
    } else if (dialogInfo.triggerType == 2 && !isPageFirstIncome(id)) {
      dialogVisible.value = true
    }
  })
  .catch((e) => {
    console.log(e)
  })

const handleCloseDialog = () => {
  dialogVisible.value = false
  if (!isNewUser()) {
    setNewUser()
  }
  const id = route.params.id?.toString()
  if (!isPageFirstIncome(id)) {
    setPageFirstIncomeInfo(id)
  }
}

onServerPrefetch(async () => {
  await initPage()
  initPageData()
})

onMounted(async () => {
  if (!productComponents.value) {
    await initPage()
    initPageData()
  }
  window.addEventListener('message', (e) => {
    if (e.data?.type === 'toWeatherCollect') {
      openWindowByquery(WEATHER_COLLECT, { docId: '0' })
    }
    if (e.data?.type === 'clickFreeGet') {
      if (!isLogin.value) {
        // useModal(
        //   ssoLogin,
        //   (success) => {
        //     setTimeout(() => {
        //       router.push(AUTH_INFO)
        //     }, 1000)
        //   },
        //   (err) => console.error(err)
        // )
        // openWindowByquery(LOGIN, {
        //   redirect: encodeURIComponent(AUTH_INFO)
        // })
        useLoginWithRedirect(window.location.origin + createorderUrl)
      } else {
        router.push(createorderUrl)
      }
    }
    if (e.data?.action === 'login-success') {
      // loginSuccessEvent(e.data?.data)
    }
  })
})

const titleIndexs = ref<number[]>([])

const bgList = ref<{ id: string; bgColor: COLOR_ENUM; isLast?: boolean }[]>([])

const getBgColor = (id: string) => {
  if (!bgList.value.length) {
    return COLOR_ENUM.BG_COLOR
  }
  const item = bgList.value.find((item) => item.id === id) || bgList.value[0]
  return item.bgColor
}

const getIsLast = (id: string) => {
  if (!bgList.value.length) {
    return false
  }
  const item = bgList.value.find((item) => item.id === id) || bgList.value[0]
  return item.isLast
}
// 根本后台设置的价格模板开关显隐
const getBlock = (item: any) => {
  if (
    item.detailShowEnable == 2 &&
    (item.type == 'card' || item.type == 'table')
  ) {
    return true
  } else {
    return false
  }
}
const currentComponent = (type: ComponentsTypeEnum) => {
  return ShowComponentMap[type]
}

// 寻找 index 区间
const findFirstIndex = (index: number) => {
  const lenght = titleIndexs.value.length
  return titleIndexs.value.findIndex((iIndex, i) => {
    return (
      (index >= iIndex && i === lenght - 1) ||
      (index >= iIndex && index < titleIndexs.value[i + 1])
    )
  })
}

const calcTtileIndex = () => {
  try {
    titleIndexs.value = componentDataList.value
      .filter((item) => item.type === ComponentsTypeEnum.TITLE)
      .map((item) => {
        return componentDataList.value.findIndex((i) => i.id === item.id)
      })
    bgList.value = componentDataList.value.map((item, index) => {
      if (item.type === ComponentsTypeEnum.CONSULT) {
        return { id: item.id, bgColor: COLOR_ENUM.WHITE, isLast: true }
      }

      const bgIndex = findFirstIndex(index)

      if (
        [ComponentsTypeEnum.PICTURE].includes(
          componentDataList.value[index]?.type
        )
      ) {
        const data = JSON.parse(
          JSON.stringify(componentDataList.value[index]?.componentsInfo)
        ) as PICTURE_COMPONENT_TYPE
        if (data.type === 'hover') {
          return {
            id: item.id,
            bgColor: bgIndex & 1 ? COLOR_ENUM.WHITE : COLOR_ENUM.BG_COLOR,
            isLast: false
          }
        }
      }

      if (
        index === componentDataList.value.length - 1 &&
        ![ComponentsTypeEnum.TITLE, ComponentsTypeEnum.CONSULT].includes(
          componentDataList.value[index]?.type
        )
      ) {
        return {
          id: item.id,
          bgColor: bgIndex & 1 ? COLOR_ENUM.WHITE : COLOR_ENUM.BG_COLOR,
          isLast: true
        }
      }

      if (bgIndex < 0) {
        return { id: item.id, bgColor: COLOR_ENUM.WHITE, isLast: false }
      }
      if (
        index > 0 &&
        componentDataList.value[index - 1]?.type === ComponentsTypeEnum.TITLE &&
        componentDataList.value[index + 1]?.type === ComponentsTypeEnum.TITLE &&
        componentDataList.value[index]?.type === ComponentsTypeEnum.PICTURE_NAV
      ) {
        // 如果是两个标题夹着文字导航，则不需要padding-bottom: 72px，是故isLast返回false
        const data = JSON.parse(
          JSON.stringify(componentDataList.value[index]?.componentsInfo)
        ) as PICTURE_NAV_TYPE
        if (data.type === 'txt') {
          return {
            id: item.id,
            bgColor: bgIndex & 1 ? COLOR_ENUM.WHITE : COLOR_ENUM.BG_COLOR,
            isLast: false
          }
        }
      }
      return {
        id: item.id,
        bgColor: bgIndex & 1 ? COLOR_ENUM.WHITE : COLOR_ENUM.BG_COLOR,
        isLast: [ComponentsTypeEnum.TITLE, ComponentsTypeEnum.CONSULT].includes(
          componentDataList.value[index + 1]?.type
        )
      }
    })
  } catch (error) {}
}

watch(
  () => componentDataList.value,
  (value) => {
    if (value?.length) {
      nextTick(() => {
        calcTtileIndex()
      })
    }
  },
  { immediate: true }
)
const routerMethod = () => {
  if (targetPageUrl.value) {
    const isExternalUrl = /^(http|https):\/\//.test(targetPageUrl.value)
    if (isExternalUrl) {
      window.location.href = targetPageUrl.value
    } else {
      router.push(targetPageUrl.value)
    }
  }
}
const openBindDialog = (data?: any) => {
  openRelatedAccountDialog({
    visible: true,
    containerComponent: relatedAccount,
    targetPageUrl: data ? data : '',
    routerMethod: routerMethod,
    ssoLogin: ssoLogin
  })
  targetPageUrl.value = data ? data : ''
}

const loginSuccess = async (data?: any) => {
  if (Cookies.get('token')) {
    return
  }
  globalStore.setToken(data.token)
  Cookies.set('token', data.token)
  await handleLoginSuccess()
  if (isHasPhone.value) {
    data.redirect && (window.location.href = data.redirect)
  } else {
    openBindDialog() //绑定手机号弹窗
  }
}

provide('isBannerImageLoad', isBannerImageLoad)

provide('authType', authType)

provide('userId', userId)

provide('token', token)

// provide('campaignIdsData', campaignIdsData)
</script>
<style lang="scss" scoped>
.solution-preview {
  width: 100%;
  min-height: 100vh;
}
.normal-dialog-enter-active,
.normal-dialog-leave-active {
  transition: opacity 0.3s;
}
.normal-dialog-enter,
.normal-dialog-leave-to {
  opacity: 0;
}
</style>
